import React from 'react'
import PropTypes from 'prop-types'
import GeneralError from './GeneralError'
let hadErrorTimeOut

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, message: '', hadError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error.message }
  }

  handleError = () => {
    this.setState({
      hasError: false,
      hadError: true,
    })
    hadErrorTimeOut = setTimeout(() => {
      this.setState({
        hadError: false,
      })
    }, 2000)
  }
  cleanup = () => {
    window.removeEventListener('get-data-success', this.handleError)
    clearTimeout(hadErrorTimeOut)
  }

  componentDidMount() {
    window.addEventListener('get-data-success', this.handleError)
  }
  componentWillUnmount() {
    this.cleanup()
  }

  render() {
    if (this.state.hasError) {
      return <GeneralError />
    }

    return React.cloneElement(this.props.children, {
      hadError: this.state.hadError,
    })
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}
